import React from 'react';
import PropTypes from 'prop-types';
import Channel from './views/Channel';
import Collection from './views/Collection';
import AnonymousSeries from './views/AnonymousSeries';
import AnonymousSeriesV2 from './views/AnonymousSeriesV2';
import Series from './views/Series';
import getAnaltytics from './helpers/AnalyticsHelper';
import Personality from './views/Personality';

const ANON_SERIES = 'ANON_SERIES';
const ANON_SERIES_V2 = 'AUTH_SERIES_V2';
const AUTH_SERIES = 'AUTH_SERIES';
const CHANNEL = 'CHANNEL';
const COLLECTION = 'COLLECTION';
const EVENT = 'EVENT';
const PERSONALITY = 'PERSONALITY';

const Hero = ({ type, hasAnalytics = true, ...rest }) => {
  const { account, item, panel, idx } = rest;
  const analytics = hasAnalytics ? getAnaltytics({ account, item, panel, idx }) : null;
  const components = {
    [CHANNEL]: Channel,
    [COLLECTION]: Collection,
    [ANON_SERIES]: AnonymousSeries,
    [AUTH_SERIES]: Series,
    [PERSONALITY]: Personality,
    [ANON_SERIES_V2]: AnonymousSeriesV2,
  };
  const Component = components[type];
  if (!type) return null;
  return <Component analytics={analytics} {...rest} />;
};

Hero.propTypes = {
  type: PropTypes.string.isRequired,
  hasAnalytics: PropTypes.bool,
};

// eslint-disable-next-line import/no-unused-modules
export { Hero, ANON_SERIES, AUTH_SERIES, CHANNEL, COLLECTION, EVENT, PERSONALITY, ANON_SERIES_V2 };
